<script>
  import { layoutMethods  } from "@/state/helpers";
  // import { contactListData } from "./data-list";
  import { prpMethods,prpComputed,exportMethods,erpFixMessages  } from "@/state/helpers";
  import Swal from "sweetalert2";
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";

  export default {
    page: {
      title: "Redemption Reward"
    },
    data() {
      return {
        title: "Redemption Reward",
        rewardListData: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90 ,100],
        filter: null,
        filterOn: [],
        sortBy: "value",
        sortDesc: false,
        searchOptions: [
          { text: 'Search All', value: null },
          { text: 'Id Number', value: 'pr.peddlrTrackingId' },
          { text: 'Name', value: 'pr.receiverName' }
        ],
        filterOptions: [
          { text: 'All', value: null },
          { text: 'Claimed', value: 'Claimed' },
          { text: 'Processing', value:  'Processing'},
          { text: 'Sent for Delivery', value: 'Sent for Delivery' },
          { text: 'Delivered', value: 'Delivered' },
          { text: 'Cancelled', value: 'Cancelled' }
        ],
        filterValue: {
            name: null,
            field: null,
        },
        searchValue: {
            name: null,
            field: null,
        },
        fields: [
          {
            key: "id_number",
            sortable: true,
          }, 
          {
            key: "name",
            sortable: true,
          },
          {
            key: "item_description",
            sortable: true,
          },
          {
            key: "process_date",
            sortable: true,
          },
          {
            key: "type",
            sortable: true,
          },
          {
            key: "receive_amount",
            sortable: true,
          },
        ],
        pagination: {
            "page": 1,
            "rows" : 10,
            "sort": "id",
            "orderDesc": true,
            "search": "",
            "search_field":  "",
            "filter":  "",
            "filter_by": "",
            "dateRange":null
        },
        rangeOption: {
          mode: "range",
        },
      };
    },
    components: { 
      flatPickr
    },
    computed: {
      ...prpComputed,
      ...erpFixMessages
    },
    methods: {
      ...layoutMethods,
      ...prpMethods,
      ...exportMethods,
      async onExport(){
          await this.onPageUpdate();
          if(this.prpRewardsTotalRows ==0){
            Swal.fire("Failed!", this.exportNullPrompt, "warning");
            return;
          }
          let params = Object.assign(
            {
              module: 'prp_reward',
              email: JSON.parse(localStorage.getItem('userData')).email,
              "sort": this.pagination["sort"],
              "orderDesc": this.pagination["orderDesc"],
              "search": this.pagination["search"],
              "search_field": this.pagination["search_field"],
              "filter": this.pagination["filter"],
              "filter_by": this.pagination["filter_by"],
              "dateRange": this.pagination["dateRange"],
            });

          
          this.exportReport(params)
            .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
            .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
        },
      async populatePrpRewards(){
        await this.onPageUpdate();
      },
      async onPageUpdate(status) {
          if(status == "reset"){
            this.pagination.page = 1;
          }
          this.pagination.search = this.searchValue.name;
          this.pagination.search_field = this.searchValue.field;
          this.pagination.filter = this.filterValue.name;
          this.pagination.filter_by = this.filterValue.field;
          await this.listPrpReward(this.pagination)
      },
      refresh(){
        this.searchValue.name = null;
        this.filterValue.name = null;
        //this.pagination.page = 1;
        this.populatePrpRewards();
        
      },
      tableSorting(action){
        var column = "";
        switch(action.sortBy){
            case 'id_number' :
                column = 'pr.peddlrTrackingId';
                break;
            case 'name' :
                column = 'pr.receiverName';
                break;
            case 'item_description' :
                column = 'pr.reward';
                break;
            case 'process_date' :
                column = 'pr.processedDate';
                break;
        }
        this.pagination.sort = column;
        this.pagination.orderDesc = action.sortDesc;
        this.listPrpReward(this.pagination)
      },
    },
    mounted(){
      this.populatePrpRewards();
      this.changeTitle({title: 'Redemption Reward'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Redemption Reward', to: { name: 'Redemption Reward'} }
        ]
      });
    }
  }
    
</script>

<template>
  <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-4 col-sm-4 mb-4">
                <div class="my-2">
                  <h5 class="card-title text-dark">
                    <span class="fw-normal ms-lg-2">{{prpRewardsTotalRows}}</span> Record(s)
                  </h5>
                </div>
              </div>

              <div class="col-md-8 col-sm-8">
                  <div class="d-flex justify-content-lg-end mb-lg-3">
                    <a
                      href="javascript:void(0);"
                      class="btn btn-primary me-2"
                      data-bs-toggle="modal"
                      @click="onExport"
                    >
                      <i class="uil uil-export me-1"></i>
                      Export
                    </a>
                      <a class="btn btn-secondary"
                        @click="refresh"
                          ><feather
                          type="refresh-ccw"
                          size="16"
                          class="icon nav-icon"
                          ></feather
                          >&nbsp;&nbsp; Refresh</a
                      >
                  </div>
              </div>
              <div class="row">
                <div class="w-auto mb-2">
                  <div class="d-flex mt-3 mb-3">
                    <div class="me-3">
                      <form class="d-flex" @submit.prevent="onPageUpdate('reset')">
                        <b-form-group id="input-group-3" label-for="input-3">
                          <b-form-select class="form-select rounded-0 rounded-start shadow-none w-200px" id="input-3" v-model="searchValue.field" :options="searchOptions"></b-form-select>
                        </b-form-group>
                        <b-form-group id="input-group-3" class="text-align-right" label-for="input-3">
                          <template v-slot:description><div class="d-flex justify-content-end">Search for keyword</div></template>
                          <b-form-input id="input-keyword" v-model="searchValue.name" class="rounded-0" style="width: auto"></b-form-input>
                        </b-form-group>
                      </form>
                    </div>
                    <div class="me-3 w-250px">
                      <b-form-group id="input-group-3" label-for="input-3">
                        <template v-slot:description><div class="d-flex justify-content-end">Filter By</div></template>
                        <b-form-select class="form-select rounded-0 rounded-start shadow-none w-150px" id="input-3" v-model="filterValue.name" :options="filterOptions"></b-form-select>
                      </b-form-group>
                    </div>
                    <div class="me-3">
                      <b-form-group>
                        <template v-slot:description><div class="d-flex justify-content-end">Filter by date added</div></template>
                        <flat-pickr
                          v-model="pagination.dateRange"
                          :config="rangeOption"
                          placeholder="Select a date range"
                          class="form-control"
                          style="width: fit-content"
                        ></flat-pickr>
                      </b-form-group>
                    </div>
                    <div class="me-3">
                      <b-form-group label="">
                        <b-button variant="primary" type="button" @click="onPageUpdate('reset')" class="px-2">
                          <i class='bx bx-search bx-fw'></i>
                          Search
                        </b-button>
                      </b-form-group>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <div class="table align-middle table-nowrap">
                  <b-table
                    :items="prpRewards"
                    :fields="fields"
                    responsive="sm"
                    :current-page="currentPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    @sort-changed="tableSorting"
                    class="table-check"
                  >
                    <!-- <template #cell(action)="data">
                        <div class="d-flex">
                          <div class="btn-group me-2 mb-2 mb-sm-0">
                              <button type="button" @click="addEditItem(data.item)"  class="btn btn-sm btn-primary">
                              <i class="bx bx-edit bx-xs bx-fw"></i>
                              </button>
                          </div>
                          <div>
                              <b-button id="show-btn" @click="deleteItem(data.item)" class="btn btn-sm btn-danger"><i class="bx bx-trash bx-xs bx-fw"></i></b-button>
                          </div>
                        </div>
                    </template> -->
                    <template #cell(id_number)="data">
                      <span class="text-body m-0"><router-link :to="{ name: 'Peddlr Points Edit', params: { peddlrTrackingId : data.item.peddlrTrackingId }}" class="customer-name">{{ data.item.peddlrTrackingId }}</router-link></span>
                    </template>

                    <template #cell(name)="data">
                      {{ data.item.receiverName }}
                    </template>
                    <template #cell(item_description)="data">
                      {{ data.item.reward }}
                    </template>
                    <template #cell(process_date)="data">
                      <span v-if="data.item.processedDate != null">
                        {{ data.item.processedDate | formatDateNoComma}}
                      </span>
                    </template>
                    <template #cell(type)="data">
                      {{ data.item.type }}
                    </template>
                    <template #cell(receive_amount)="data">
                      {{ data.item.rewardAmount | toCurrency }}
                    </template>
                    
                  </b-table>
                </div>
              </div>
              <div class="row g-0 text-center" v-if="prpRewardsTotalRows == 0">
                <span>No data to display.</span>
              </div>
              <div class="row g-0 text-center text-sm-start" v-if="prpRewardsTotalRows != 0 && prpRewardsTotalRows > 10">
              <!-- end col -->
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <div class="form-group row pull-left">
                      <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                      <div class="col-sm-6">
                        <b-form-group label-for="display-record">
                          <b-form-select class="form-select shadow-none w-fit"
                            id="display-record"
                            v-model="pagination.rows"
                            :options="pageOptions"
                            @change="onPageUpdate()"
                          ></b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                    <div
                      class="
                        dataTables_paginate
                        paging_simple_numbers
                        float-end
                      "
                    >
                      <!-- pagination -->
                      <div class="row g-0 text-center" v-if="prpRewardsTotalRows == 0">
                        <span>No data to display.</span>
                      </div>
                      <b-pagination
                        v-if="prpRewardsTotalRows != 0 && prpRewardsTotalRows > pagination.rows"
                        class="pagination-rounded"
                        v-model="pagination.page"
                        :total-rows="prpRewardsTotalRows"
                        @input="onPageUpdate()"
                        :per-page="pagination.rows"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
              <!-- end col -->
            </div>
            <!-- end row -->
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
</template>


<style scoped>
  .btn {
    cursor: pointer;
  }
</style>